<template>
  <div class="warehouseList">
    <el-button class="addWarehouse" @click="addWarehouse = true"
      >添加仓库</el-button
    >
    <div class="data">
      <el-table
        :data="tableData"
        style="width: 99%; margin: 0.5%"
        row-key="id"
        height="100%"
        border
        default-expand-all
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        <el-table-column label="id" align="center" width="200">
          <template slot-scope="scope" v-if="tableData != null">
            {{ scope.row.id }}
          </template>
        </el-table-column>
        <el-table-column label="仓库名称" align="center" width="100">
          <template slot-scope="scope" v-if="tableData != null">
            {{ scope.row.name }}
          </template>
        </el-table-column>
        <el-table-column label="地区" align="center" width="200">
          <template slot-scope="scope" v-if="tableData != null">
            {{ scope.row.area }}
          </template>
        </el-table-column>
        <el-table-column label="详细地址" align="center" width="380">
          <template slot-scope="scope" v-if="tableData != null">
            {{ scope.row.address }}
          </template>
        </el-table-column>
        <el-table-column label="负责人" align="center" width="200">
          <template slot-scope="scope" v-if="tableData != null">
            {{ scope.row.chargePerson }}
          </template>
        </el-table-column>
        <el-table-column label="联系方式" align="center" width="200">
          <template slot-scope="scope" v-if="tableData != null">
            {{ scope.row.phone }}
          </template>
        </el-table-column>
        <el-table-column label="设备数量" align="center" width="100">
          <template slot-scope="scope" v-if="tableData != null">
            {{ scope.row.deviceCount }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template v-if="tableData != null" slot-scope="scope">
            <el-button
              type="text"
              @click="getWarehouseInfo(scope.row.id), (editWarehouse = true)"
              >编辑</el-button
            >
            <!-- <el-button type="text">添加下级</el-button> -->
            <el-button type="text" @click="delWarehouseMethod(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="添加仓库" :visible.sync="addWarehouse" width="30%">
      <el-form
        ref="form"
        :model="addWarehouseDto"
        label-width="100px"
        label-position="right"
      >
        <el-form-item label="仓库名称" required="true">
          <el-input v-model="addWarehouseDto.name"></el-input>
        </el-form-item>
        <el-form-item label="地区">
          <el-select
            v-model="addWarehouseDto.provinceStr"
            @change="selectProvince"
            clearable="true"
            placeholder="省"
            style="width: 32%"
          >
            <el-option
              v-for="(item, index) in provinceOptions"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="addWarehouseDto.cityStr"
            @change="selectCity"
            clearable="true"
            placeholder="市"
            style="width: 32%"
          >
            <el-option
              v-for="item in cityOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="addWarehouseDto.areaStr"
            @change="selectArea"
            clearable="true"
            placeholder="区"
            style="width: 32%"
          >
            <el-option
              v-for="item in areaOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="详细地址" required="true">
          <el-input v-model="addWarehouseDto.address"></el-input>
        </el-form-item>
        <el-form-item label="仓库负责人">
          <el-select
            v-model="chargePerson"
            @change="selectChargePerson"
            clearable="true"
            placeholder="仓库负责人"
            style="width: 100%"
          >
            <el-option
              v-for="item in pcUsers"
              :key="item.id"
              :label="item.name + '(' + item.phone + ')'"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addWarehouse = false">取 消</el-button>
        <el-button type="primary" @click="addWarehouseMethod()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="编辑仓库" :visible.sync="editWarehouse" width="30%">
      <el-form
        ref="form"
        :model="warehouseInfo"
        label-width="100px"
        label-position="right"
      >
        <el-form-item label="仓库ID">
          <el-input v-model="warehouseInfo.id" disabled></el-input>
        </el-form-item>
        <el-form-item label="仓库名称" required="true">
          <el-input v-model="warehouseInfo.name"></el-input>
        </el-form-item>
        <el-form-item label="地区">
          <el-select
            v-model="warehouseInfo.provinceStr"
            @change="updateSelectProvince"
            clearable="true"
            placeholder="省"
            style="width: 32%"
          >
            <el-option
              v-for="(item, index) in updateProvinceOptions"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="warehouseInfo.cityStr"
            @change="updateSelectCity"
            clearable="true"
            placeholder="市"
            style="width: 32%"
          >
            <el-option
              v-for="item in updateCityOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="warehouseInfo.areaStr"
            @change="updateSelectArea"
            clearable="true"
            placeholder="区"
            style="width: 32%"
          >
            <el-option
              v-for="item in updateAareaOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="详细地址" required="true">
          <el-input v-model="warehouseInfo.address"></el-input>
        </el-form-item>
        <el-form-item label="仓库负责人">
          <el-select
            v-model="warehouseInfo.chargePerson"
            @change="updateSelectChargePerson"
            clearable="true"
            placeholder="仓库负责人"
            style="width: 100%"
          >
            <el-option
              v-for="item in pcUsers"
              :key="item.id"
              :label="item.name + '(' + item.phone + ')'"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editWarehouse = false">取 消</el-button>
        <el-button type="primary" @click="updateWarehouseMethod()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getWarehouse,
  getArea,
  getPsUser,
  addWarehouseRequest,
  getWarehouseInfoById,
  updateWarehouse,
  delWarehouse,
} from "../../../api/warehousemanagement/warehouseList.js";
export default {
  name: "WarehouseList",
  data() {
    return {
      tableData: "",
      addWarehouse: false,
      editWarehouse: false,
      addWarehouseDto: {
        name: "",
        province: "",
        provinceStr: "",
        city: "",
        cityStr: "",
        area: "",
        areaStr: "",
        address: "",
        userId: "",
      },
      warehouseInfo: {
        id: "",
        name: "",
        province: "",
        provinceStr: "",
        city: "",
        cityStr: "",
        area: "",
        areaStr: "",
        address: "",
        userId: "",
        chargePerson: "",
      },
      chargePerson: "",
      pcUsers: "",
      provinceOptions: "",
      cityOptions: "",
      areaOptions: "",
      updateProvinceOptions: "",
      updateCityOptions: "",
      updateAareaOptions: "",
      boxTitle: "",
      boxMessage: "",
    };
  },
  methods: {
    selectProvince(id) {
      this.addWarehouseDto.city = "";
      this.addWarehouseDto.cityStr = "";
      this.addWarehouseDto.area = "";
      this.addWarehouseDto.areaStr = "";
      for (let item of this.provinceOptions) {
        if (id == item.id) {
          this.addWarehouseDto.province = item.code;
          this.addWarehouseDto.provinceStr = item.name;
          this.cityOptions = item.childrenDictList;
        }
      }
    },
    selectCity(id) {
      this.addWarehouseDto.area = "";
      this.addWarehouseDto.areaStr = "";
      for (let item of this.cityOptions) {
        if (id == item.id) {
          this.addWarehouseDto.city = item.code;
          this.addWarehouseDto.cityStr = item.name;
          this.areaOptions = item.childrenDictList;
        }
      }
    },
    selectArea(id) {
      for (let item of this.areaOptions) {
        if (id == item.id) {
          this.addWarehouseDto.area = item.code;
          this.addWarehouseDto.areaStr = item.name;
        }
      }
    },
    updateSelectProvince(id) {
      this.warehouseInfo.city = "";
      this.warehouseInfo.cityStr = "";
      this.warehouseInfo.area = "";
      this.warehouseInfo.areaStr = "";
      for (let item of this.updateProvinceOptions) {
        if (id == item.id) {
          this.warehouseInfo.province = item.code;
          this.warehouseInfo.provinceStr = item.name;
          this.updateCityOptions = item.childrenDictList;
        }
      }
    },
    updateSelectCity(id) {
      this.warehouseInfo.area = "";
      this.warehouseInfo.areaStr = "";
      for (let item of this.updateCityOptions) {
        if (id == item.id) {
          this.warehouseInfo.city = item.code;
          this.warehouseInfo.cityStr = item.name;
          this.updateAareaOptions = item.childrenDictList;
        }
      }
    },
    updateSelectArea(id) {
      for (let item of this.updateAareaOptions) {
        if (id == item.id) {
          this.warehouseInfo.area = item.code;
          this.warehouseInfo.areaStr = item.name;
        }
      }
    },
    selectChargePerson(id) {
      this.addWarehouseDto.userId = id;
    },
    updateSelectChargePerson(id) {
      this.warehouseInfo.userId = id;
    },
    addWarehouseMethod() {
      addWarehouseRequest(this.addWarehouseDto).then((result) => {
        if (result.code == "000000") {
          this.boxTitle = "成功";
          this.boxMessage = "添加成功";
          this.open();
          this.addWarehouse = false;
          getWarehouse().then((result) => {
            this.tableData = result.data;
          });
        } else {
          this.boxTitle = "错误";
          this.boxMessage = result.message;
          this.open();
        }
      });
    },
    updateWarehouseMethod() {
      updateWarehouse(this.warehouseInfo).then((result) => {
        if (result.code == "000000") {
          this.boxTitle = "成功";
          this.boxMessage = "添加成功";
          this.open();
          this.editWarehouse = false;
          getWarehouse().then((result) => {
            this.tableData = result.data;
          });
        } else {
          this.boxTitle = "错误";
          this.boxMessage = result.message;
          this.open();
        }
      });
    },
    open() {
      const h = this.$createElement;
      this.$msgbox({
        title: this.boxTitle,
        message: h("p", null, [h("span", null, this.boxMessage)]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            done();
          } else {
            done();
          }
        },
      });
    },
    getWarehouseInfo(id) {
      getWarehouseInfoById(id).then((result) => {
        this.warehouseInfo = result.data;
        console.log(this.warehouseInfo);
      });
    },
    delWarehouseMethod(id) {
      let delWarehouseDto = {
        id: id,
      };
      delWarehouse(delWarehouseDto).then((result) => {
        if (result.code == "000000") {
          this.boxTitle = "成功";
          this.boxMessage = "操作成功";
          this.open();
          getWarehouse().then((result) => {
            this.tableData = result.data;
          });
        }else{
          this.boxTitle = "错误";
          this.boxMessage = result.message;
          this.open();
        }
      });
    },
  },
  mounted() {
    getWarehouse().then((result) => {
      this.tableData = result.data;
    });
    getArea().then((result) => {
      this.provinceOptions = result.data;
      this.updateProvinceOptions = result.data;
    });
    getPsUser().then((result) => {
      this.pcUsers = result.data;
    });
  },
};
</script>

<style scoped>
.warehouseList {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
}
.data {
  width: 100%;
  height: 80%;
}
.addWarehouse {
  width: 10%;
  height: 5%;
  background-color: #4691f3;
  color: #fff;
  float: left;
  margin: 0.5%;
}
/deep/ .el-input__inner {
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/warehouse/warehousemanagement/warehouselist.vue